import { render, staticRenderFns } from "./modalGeneros.vue?vue&type=template&id=27dc2e28&scoped=true&"
import script from "./modalGeneros.vue?vue&type=script&lang=js&"
export * from "./modalGeneros.vue?vue&type=script&lang=js&"
import style0 from "./modalGeneros.vue?vue&type=style&index=0&id=27dc2e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dc2e28",
  null
  
)

export default component.exports